// interfaces
export interface amountItem {
    fillValue: number,
    giftRatio: number,
    codingRequirement: number,
}
export interface Response {
    code: number;
    msg: string;
    data?: any;
}

export interface PayChannel {
    id: number;
    name: string;
}
export interface DepositData {
  channelList: PayChannel[];         
  turnOverValue: number;
  activeChannel: Record<string, any>;
  showCPFIdError: boolean;
  selectedAmount: number | string;
  selecTopup: boolean;
  giftAmount: number;
  isFillField: boolean;
  isSuccess: boolean;
  toastContent: string;
  cpfID:string
  min_amount:number|string,
  max_amount: number|string,
  amountList:amountItem[],
  ercCode : string,
  minErcAmount: string,
  maxErcAmount: string
}

// function
import { Ref } from 'vue'

export const callDoNotshowFunc = async (
  callFirstRechargePopupNotShow: () => Promise<any>,
  loadingRef: Ref<any>,
  showSuccess: (msg: string) => void,
  showError: (message: string) => void,
  userStore: any,
  show: Ref<boolean>
) => {
  try {
    const res = await callFirstRechargePopupNotShow()
    loadingRef.value.close()
    showSuccess(res.msg)
    userStore.setFirstRechargePopupShowStatus(0)
    userStore.setisFirstRechargeRewardEligible(false)
    show.value = false
  } catch (err:any) {
    show.value = false
    loadingRef.value.close()
    showError(err)
  }
}
